import React from 'react';
import { Droppable, DropResult } from 'react-beautiful-dnd';
import { AnyEmptyQuestion, Section } from '../../../../types';
import DraggableSectionContainer from './DraggableSectionContainer';
import { QuestionsListContainer } from '../styles';
import AddQuestionButton from '../components/AddQuestionButton';
import { useSelector } from 'react-redux';
import { selectIsEditingAnyQuestion } from '../../../../../../redux/questionnaire/selectors';

interface DroppableSectionsListProps {
  questions: AnyEmptyQuestion[];
  sections: Section[];
  onDragEnd: (result: DropResult) => void;
}

function DroppableSectionsList({ questions, sections, onDragEnd }: DroppableSectionsListProps) {
  const isEditingAnyQuestion = useSelector(selectIsEditingAnyQuestion);

  return (
    <Droppable droppableId="sections" type="SECTION">
      {provided => (
        <QuestionsListContainer ref={provided.innerRef} {...provided.droppableProps}>
          {sections.map((section, index) => (
            <DraggableSectionContainer key={section.section} section={section} index={index} questions={questions} />
          ))}
          {provided.placeholder}
          {!isEditingAnyQuestion && <AddQuestionButton />}
        </QuestionsListContainer>
      )}
    </Droppable>
  );
}

export default DroppableSectionsList;
